export const eventStatuses = {
  0: {
    type: 'brand-6',
    icon: 'draft'
  },
  1: {
    type: 'success',
    icon: 'published'
  }
}